import React, { useContext, useEffect, useState } from 'react'
import { AppSettings } from '../../../../../config/app-settings'
import { Link, useParams } from 'react-router-dom'
import { toast } from 'react-toastify'
import Loader from '../../../../pages/loader'
import ReusableTable from '../../../../../components/other/ReuseableTable'
import { useGetUgcSearchAggregateDomainQuery } from '../../../../../redux/apis/linkManagement/ugc/lMUgcSearchApiSlice'

const UgcSearchCampaignsByDomain = () => {
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10
  })

  const context = useContext(AppSettings)
  const { id } = useParams()

  const { data, isLoading, error, refetch, isFetching } =
    useGetUgcSearchAggregateDomainQuery({
      expand: ['inserted_by'].join(','),
      page: pagination.current,
      page_size: pagination.pageSize,
      fields: ['inserted_by', 'url', 'domain_id', 'domain_name'].join(','),
      campaignId: id
    })

  let columns = [
    {
      title: 'Domain ID',
      dataIndex: 'domain_id',
      key: 'domain_id',

    },
    {
      title: 'Domain NAME',
      dataIndex: 'domain_name',
      key: 'domain_name',
      search: true
    },

    {
      title: 'SCREENSHOTS COUNT',
      dataIndex: 'to_review_count',
      key: 'to_review_count',
      search: true
    },

    {
      title: 'Actions',
      dataIndex: 'campaign_id',
      key: 'actions',
      render: (text, record) => (
        <div className='flex gap-2'>
          <a
            target='_blank'
            rel='noopener noreferrer'
            href={`/reviewing-screenshots/ugc-search/campaign/${id}/review/${record?.domain_id}`}
            className='btn btn-outline-theme'
          >
            Review
          </a>
        </div>
      )
    }
  ]

  const handleTableChange = (paginationInfo) => {
    setPagination({
      current: paginationInfo.current,
      pageSize: paginationInfo.pageSize
    })
  }

  useEffect(() => {
    console.log(error)
    if (error) {
      toast.error(error)
    }
  }, [error])

  useEffect(() => {
    context.setAppHeaderNone(false)
    context.setAppSidebarNone(false)
    context.setAppContentClass('')
    context.setAppThemePanal(true)

    return () => {
      context.setAppHeaderNone(true)
      context.setAppSidebarNone(true)
      context.setAppContentClass('p-0')
      context.setAppThemePanal(false)
    }
  }, [context]) // Add context as a dependency

   useEffect(() => {
      if (data?.data?.length === 0) {
        toast.info('All links processed. Closing tab...')
        const timeout = setTimeout(() => {
          window.close()
        }, 1500)
  
        return () => clearTimeout(timeout)
      }
    }, [data?.data?.length])

  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        refetch()
      }
    }

    document.addEventListener('visibilitychange', handleVisibilityChange)

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange)
    }
  }, [refetch])

  return (
    <div className='w-full flex flex-col'>
      <Loader isLoading={isLoading || isFetching} />

      <div className='row'>
        <ReusableTable 
          columns={columns} 
          data={data?.data} 
          pagination={{
            current: pagination.current,
            pageSize: pagination.pageSize,
            total: data?.count
          }}
          onChange={handleTableChange}
        />
      </div>
    </div>
  )
}

export default UgcSearchCampaignsByDomain
